import { PreviewPdfLayout } from '@/layouts/PreviewPdfLayout';
import { ResultsPdfModel } from '@/components/Pdf/Models/ResultsPdfModel';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useGetResultByVehiculeCheckId } from '@/hooks/vehicule-check-result.hooks';
import { useGetVehiculeCheckById } from '@/hooks/vehicule-check.hooks';
import { getPdfFooterCopyrightText } from '@/utils/pdf-footer.utils';

export const ResultsPreviewPdfPage = () => {
  const { id } = useParams();
  const { t } = useTranslation('inspection');

  const { data: vehiculeCheck, isLoading: isLoadingVehiculeCheck } =
    useGetVehiculeCheckById(`${id}`);

  const { data: vehiculeCheckResult, isLoading: isLoadingVehiculeCheckResult } =
    useGetResultByVehiculeCheckId(id);

  const footerCopyrightText = getPdfFooterCopyrightText({
    t,
    date: vehiculeCheck?.data?.createdAt,
    id: vehiculeCheck?.data?.shortId,
    licensePlateNumber:
      vehiculeCheck?.data?.vehicule?.licensePlateNumber ||
      vehiculeCheckResult?.data?.valueImmatriculation,
    vin:
      vehiculeCheck?.data?.vehicule?.vin || vehiculeCheckResult?.data?.valueVin,
  });

  const model = (
    <ResultsPdfModel
      t={t}
      isLoading={isLoadingVehiculeCheck || isLoadingVehiculeCheckResult}
      vehiculeCheck={vehiculeCheck?.data}
      vehiculeCheckResult={vehiculeCheckResult?.data}
    />
  );

  return (
    <PreviewPdfLayout
      t={t}
      filename={`inspection-lucius-${vehiculeCheck?.data?.shortId}`}
      footerCopyrightText={footerCopyrightText}
      pdfModel={model}
    >
      {model}
    </PreviewPdfLayout>
  );
};
